import { t } from "@hakili/i18n";
import { Button, Card } from "@hakili/ui";

/**
 * `S5-1 (a)`: **the screen between the verified code and the new PIN, for a number that already has an account.** Continuing replaces the
 * account's PIN (`setDevicePin` is an unconditional overwrite), so the choice is explicit and has two buttons: no passive notice, no default.
 */
export function ExistingAccount({
  phone,
  confirm,
  cancel,
}: {
  readonly phone: string;
  readonly confirm: () => void;
  readonly cancel: () => void;
}): React.JSX.Element {
  return (
    <Card shape="client" className="flex flex-col gap-4">
      <h1 className="text-xl font-semibold text-gray-900" data-testid="compte-existant-titre">
        {t("client.compteExistant.titre")}
      </h1>
      <p className="text-sm text-gray-500" data-testid="compte-existant-corps">
        {t("client.compteExistant.corps").replace("{numero}", phone)}
      </p>
      <Button type="button" onClick={confirm} data-testid="compte-existant-continuer">
        {t("client.compteExistant.continuer")}
      </Button>
      <button
        type="button"
        onClick={cancel}
        data-testid="compte-existant-annuler"
        className="text-sm font-medium text-indigo-700"
      >
        {t("client.compteExistant.annuler")}
      </button>
    </Card>
  );
}
